<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <style>
  
     .body {
        font-family: Arial, sans-serif;
        background-color: #e6e6e6;   /* Set background color */
        max-width: 100%;
        max-height: 100%;
        /* scrollbar-width: none; */
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden; /* Completely removes scrollbars */
        overflow-y: hidden !important;
        -ms-overflow-style: none;
        
    }

    .container {
      font-family: Arial, sans-serif;
      background-color: #e6e6e6; /* Keep full background */
      /* min-height: 100vh; */ /* Ensure background is always visible */
      margin: 0;
      display: flex;
      flex-direction: column;
      height: 100vh; /* Makes sure it takes full screen */
      max-width: 100%;
      overflow: hidden; /* Completely removes scrollbars */
      /* overflow-y: hidden; */ /* Specifically removes vertical scrollbar */
      overflow-y: hidden !important;
      border-radius: 10px;
      border: 1px solid #dee2e6;
      padding: 20px;
      font-family: Arial, sans-serif;
      
    }

    .form-grid {
      display: grid;
      grid-template-columns: 130px 261px 133px 264px;
      gap: 15px;
      align-items: center;
      margin-bottom: 20px;
    }

    label {
      font-weight: bold;
    }

    input[type="text"],
    input[type="number"] {
      width: 100%;
      padding: 8px;
      border: 1px solid #ced4da;
      border-radius: 5px;
    }

.unit-selection-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.radio-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.radio-buttons label {
  display: flex;
  align-items: center;
  gap: 5px;
}
    .results-header {
      text-align: left;
      font-weight: bold;
      font-size: 20px;
      margin-top: 30px;
      margin-left: 6.5cm; /* Adjusted for positioning */
    }

    table {
      width: 60%;
      border-collapse: collapse;
      margin: 20px auto;
      border: 4px double black;
    }

    td, th {
      border: 4px double black;
      padding: 10px;
      text-align: center;
      background-color: #d9d9d9; /* Background color for table cells */
    }

    .status-box {
      background-color: green;
      width: 50px;
      height: 20px;
      margin: auto;
      padding: 5px;
    }

    .btn-container {
      display: flex;
      justify-content: center;
      margin-top: 28px;
      margin-left: 18cm;
      gap: 1cm; 
    }

    .dialog-button {
      width: 11px !important; /* Set the width of the button to 12px */
      height: 30px; /* Set the desired height of the button */
      padding: 4px 30px;  /* Adjusted padding */
      background-color: #007bff;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }

    .dialog-button:hover {
      background-color: #007bff;
    }

    /* Rectangle box styles */
    .rectangle-box {
      border: 2px solid #bfbfbf;
      padding: 22px;
      margin: -30px auto;
      width: 90%;  /* Adjust width as needed */
      max-width: 958px;
      border-radius: 10px;
    }
    
    .results-section {
  background-color: #e6e6e6 !important;
  overflow-y: hidden !important; /* Specifically removes vertical scrollbar */
} 
   
  </style>
</head>
<body class="body">
  <ngx-spinner></ngx-spinner>

  <div *ngIf="isTokenValidated">
    <header>
      <div class="blue-box" translate>goodwill.i18n.label.title</div>
    </header>

    <div class="container">
      <h1 style="text-align: center; font-size: 16px; font-weight: bold;"><BR></h1> 
      <!-- Rectangle Box Start -->
        <form (ngSubmit)="onSubmit()">
          <div class="rectangle-box">
          <div class="form-grid">
            <!-- VIN Field -->
             <label for="vin" translate>goodwill.i18n.header.vin</label>
                  <input type="text" id="vin" [(ngModel)]="vin" name="vin" [readonly]="vinReadOnly" [placeholder]="vinPlaceholder"
                  maxlength="17" (input)="restrictSpecialChars($event)" />
                        <!-- Brand Label -->
            <label for="brand" translate>goodwill.i18n.header.brand</label>
            <span style="display: block; text-align: left; margin-left: 30px;">{{ brand }}</span>    <!-- Display brand label -->
            
                        <!-- Part Reference -->
             <label for="partReference" translate>goodwill.i18n.header.partReference</label>
                        <input type="text" id="partReference" [(ngModel)]="partReference" name="partReference"
                            [placeholder]="partReferencePlaceholder" required maxlength="15" (input)="restrictSpecialChars($event)" />

                        <!-- Current Mileage with Inline Radio Buttons -->
            <label for="currentMileage" translate>goodwill.i18n.header.currentMileage</label>
            <div class="unit-selection-inline">
                            <input type="text" id="currentMileage" [(ngModel)]="currentMileage" name="currentMileage"
                                [placeholder]="currentMileagePlaceholder" required (input)="restrictNumbers($event)" />
                            <!-- <label class="mt-3 ml-5"> -->
              <div class="radio-buttons">
              <label >
                 <input class="mt-2" type="radio" name="unit" [(ngModel)]="unit" [value]="'KM'" />
                <span translate>goodwill.i18n.unit.km</span>
              </label>
              <label>
                <input class="mt-2" type="radio" name="unit" [(ngModel)]="unit" [value]="'MLS'" /> 
                <span translate>goodwill.i18n.unit.miles</span>
              </label>
               </div>
            </div>
          </div>
            <div class="btn-container">
             <input class="dialog-button" type="submit" [value]="oktranlation" /> 
            <input class="dialog-button" type="button" [value]="cleartranlation" (click)="clearForm()"/>
          </div>
             </div>
      <!-- Rectangle Box End -->
    <BR> 
    <BR> 
       
      <!-- Results Section -->
       <div #resultsSection class="results-section" style="display: none;"> <!-- Initially hidden  -->
       
        <div class="results-header" style="width: 50%; margin: 0 auto; text-align: center;">
        <mat-label translate>goodwill.i18n.results.title</mat-label>
        </div>
        
        <table class="custom-table">
          <tr>
            <td style="text-align: left;" translate>goodwill.i18n.header.statusRequest</td>
            <td>
              <div class="status-box" [ngStyle]="{'background-color': statusRequestColor}"></div>
            </td>
            <td style="text-align: left;" translate>goodwill.i18n.header.approvalStatus</td>
            <td>{{ approvalStatus }}</td>
          </tr>
          <tr>
            <td style="text-align: left;" translate>goodwill.i18n.result.labourAcknowledged</td>
            <td>{{ labourAcknowledged }}%</td>
            <td style="text-align: left;" translate>goodwill.i18n.result.materialAcknowledged</td>
            <td>{{ materialAcknowledged }}%</td>
          </tr>
        </table>
      </div>
       </form>
    </div>
  </div>
</body>
</html>
